/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { IApi } from "../../api/api";

interface IProps {
    api: IApi;
}

export class AboutUs extends React.PureComponent<IProps, {}> {
    public render() {
        const { api } = this.props;
        return (
            <div className="container">
                <div className="section">
                    <h3>We Are Scaper</h3>
                    <h5>Our adventure creating the premier landscaping service.</h5>
                    <p>
                        At Scaper, our mission is to be the go to service for solving all of your landscaping needs.
                        {" "}(Run On){" "}
                        <em>dedicated to serving both providers and consumers across an easy to use digital experience.</em>
                        We want to grow the landscapgin industry by connecting landscapers to new customers and make it
                        {" "}easier for more people to earn an income through hard work. Easy for anyone maintain their
                        property safely without the need for manual labor nor even needing to maintain your equipment again.
                    </p>
                    <p>
                        Stay inside, enjoy your day, let us Scape your lawn.
                    </p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>What we do.</h5>
                    <p>Scaper connects consumers with landscapers through an online app.</p>
                    <p>Existing landscapers can grow their customer base reaching out to new markets.</p>
                    <p>Entrepreneurs are empowered to earn money, using Scaper to identify unmet demand in their communities.</p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>The Team.</h5>
                    <p>Bruce L. Hartman</p>
                    <p>Thomas F. Hasner</p>
                    <p>Daniel Castellanos</p>
                </div>

                <div className="divider"></div>

                <div className="section">
                    <h5>Our future is always greener.</h5>
                    <p>We want to grow.</p>
                    <p>We have goals.</p>
                </div>
            </div>
        );
    }
}
